<template>
  <div class="container-file-preview d-flex-wl">
    <!-- view/hide file preview -->
    <div>
      <input
        type="checkbox"
        id="filePrev"
        name="filePrev"
        v-model="formatVars.isFilePreview"
      />
      <label for="filePrev" style="margin-left: 10px;"
        >{{ companyName }} file preview</label
      >
      <div
        :class="
          formatVars.screenHeight > 700
            ? 'container-actions-upload-file-xl'
            : 'container-actions-upload-file-xs'
        "
      >
        <div>
          Sheet name → <strong>{{ sheetName }}</strong>
        </div>
        <div v-if="showTradeDate" class="container-trade-date">
          <label for="icon" style="width: 12rem;">Trade date</label>
          <Calendar
            id="icon"
            v-model="formatVars.tradeDate"
            :showIcon="true"
            placeholder="yyyy/mm/dd"
            dateFormat="yy/mm/dd"
            :icon="'fa fa-calendar'"
            @date-select="handleTradeDate($event)"
            :className="formatVars.focusStyle"
          />
        </div>
      </div>
    </div>
    <!-- Img -->
    <div class="container-img-preview">
      <template v-if="formatVars.isFilePreview">
        <template v-if="urlImg && !formatVars.isImageError">
          <i class="fa fa-external-link" @click="openImageInNewWindow"></i>
          <img :src="urlImg" :alt="'company file'" @error="handleImageError" />
        </template>
        <template v-else>
          <i class="fa fa-file-image-o"></i>
          <span>There was a problem loading the image</span>
        </template>
      </template>
      <template v-else>
        <img :src="formatVars.prevImg" alt="previewImg" />
      </template>
      <!-- Download -->
      <div class="container-download">
        <a href="#" @click.prevent="downloadFile" class="link-download-file">
          <i class="fa fa-download"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import previewImage from "@/assets/images/previewImg.png";
import Calendar from "primevue/calendar/Calendar";

export default {
  name: "FilePreview",
  components: {
    Calendar,
  },
  props: {
    urlImg: { required: false, default: "" },
    urlFile: { required: false, default: "" },
    companyName: { required: true, default: "" },
    sheetName: { required: true, default: "" },
    showTradeDate: { required: false, default: false },
    canClearTradeDate: { required: false, default: false },
    isFocusCalendar: { required: false, default: null },
  },
  created() {
    this.updateScreenHeight();
  },
  data() {
    return {
      formatVars: {
        isFilePreview: true,
        isImageError: false,
        focusStyle: "",
        prevImg: previewImage,
        screenHeight: 0,
        tradeDate: "",
      },
    };
  },
  watch: {
    urlImg: {
      handler() {
        Object.assign(this.formatVars, {
          isImageError: false,
        });
      },
      deep: true,
    },
    showTradeDate() {
      this.clearTradeDate();
    },
    canClearTradeDate() {
      this.clearTradeDate();
    },
    companyName: {
      handler() {},
      deep: true,
    },
    isFocusCalendar: {
      handler(newVal) {
        if (!newVal && !this.formatVars.tradeDate) {
          this.formatVars.focusStyle = "bdr_fwd_highlight";
        } else {
          this.formatVars.focusStyle = "";
        }
      },
      deep: true,
    },
  },
  methods: {
    updateScreenHeight() {
      const height = window.innerHeight;
      this.formatVars.screenHeight = height;
    },
    handleTradeDate(date) {
      this.$emit("handleTradeDate", date);
    },
    handleImageError() {
      Object.assign(this.formatVars, {
        isImageError: true,
      });
    },
    clearTradeDate() {
      const date = "";
      Object.assign(this.formatVars, {
        tradeDate: date,
      });
      this.handleTradeDate(date);
    },
    openImageInNewWindow() {
      window.open(this.urlImg, "_blank");
    },
    async downloadFile() {
      try {
        const response = await fetch(this.urlFile);
        if (!response.ok) throw new Error("Network response was not ok");
        const arrayBuffer = await response.arrayBuffer();

        const fileExtension = this.urlFile.match(/\.[^/.]+$/i)[0];
        let contentType = "";

        switch (fileExtension) {
          case ".xlsx":
            contentType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            break;
          case ".xlsm":
            contentType = "application/vnd.ms-excel.sheet.macroEnabled.12";
            break;
          default:
            contentType = "";
        }

        const blob = new Blob([arrayBuffer], { type: contentType });
        const fileNameWithExt = this.urlFile.match(/\/([^/?#]+)$/i)[1];
        const fileNameNonExt = fileNameWithExt.replace(/\.[^/.]+$/, "");
        const fileName = `${this.companyName} ${fileNameNonExt}${fileExtension}`;

        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error("There was an error downloading the file:", error);
      }
    },
  },
};
</script>

<style>
div.container-trade-date
  > span
  > .p-datepicker-trigger.p-button.p-component.p-button-icon-only {
  height: 25px;
  background: transparent !important;
  border-color: transparent;
  position: absolute;
  right: 0;
}
</style>
